import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteDesignation,
  getDesignation,
  getallLoan,
  getEmployee,
  getLoanType,
  insertDesignation,
  insertallLoan,
  InsertLoan,
  getLoan,
  getLoanPaymentType,
  deleteLoan,
  getBanckName,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import Select from "react-select";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Link } from "react-router-dom";
import { getSecureItem } from "../../services/SecureStorage";

export default function Loan() {
  const UID = getSecureItem("userId");
  const [addLoanModal, setaddLoanModal] = useState(false);
  const [EditLoanModal, setEditLoanModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allLoan, setAllLoan] = useState([]);

  const [LoanType, setloanType] = useState([]);
  const [BankName, setBankName] = useState([]);

  const [LoanPaymentType, setloanPaymentType] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [DeleteLoanId, setDeleteLoanId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const openEditLoanModal = (data) => {
    setEditLoanModal(!EditLoanModal);
    setLoanData(data);
  };

  const [LoanData, setLoanData] = useState({
    Id: null, // UniqueIdentifier
    Name: "", // nvarchar
    Branch: "", // nvarchar
    Number: "", // nvarchar
    EmployeeId: null, // UniqueIdentifier
    DueDate: "", // datetime
    Amount: null, // float
    DueAmount: null, // float
    PaymentType: null, // int
    NoofDues: null, // int
    StartDate: null, // datetime
    EndDate: null, // datetime
    LoanType: null, // UniqueIdentifier
    UserId: UID || null, // UniqueIdentifier (Dynamic user ID)
    month: "",
    Year: "",
  });

  // Handle change for React Select
  const handleSelectChange = (selectedOption) => {
    setLoanData((prev) => ({
      ...prev,
      EmployeeId: selectedOption ? selectedOption.value : "",
    }));
  };

  const openaddLoanModal = () => {
    setLoanData({});

    setaddLoanModal(!addLoanModal);
  };

  useEffect(() => {
    const fetchLoanType = async () => {
      try {
        const response = await getLoanType(UID);
        // const responses = await getDepartments(UID);

        // setDepartment(responses.data.data);
        // console.log(department,"dept");

        setloanType(response.data.data);
        console.log(LoanType, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchLoanType();
  }, []);



  useEffect(() => {
    const fetchAdditionDeductionType = async () => {
      try {
        const response = await getBanckName(UID);
        console.log(response.data.data, 'sasasasa');

        setBankName(response.data.data);
      } catch (error) {
        console.error("Error fetching addition/deduction types:", error);
      }
    };

    fetchAdditionDeductionType();
  }, [UID]);

  useEffect(() => {
    const fetchLoanPayementType = async () => {
      try {
        const response = await getLoanPaymentType(UID);
        // const responses = await getDepartments(UID);

        // setDepartment(responses.data.data);
        // console.log(department,"dept");

        setloanPaymentType(response.data.data);
        console.log(LoanPaymentType, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };
    fetchLoanPayementType();
  }, []);

  const [Employee, setEmployee] = useState([]);
  useEffect(() => {
    const fetchAllemployees = async () => {
      try {
        const response = await getEmployee(UID);

        setEmployee(response.data.data);
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchAllemployees();
  }, [UID]);

  // const [allLoan,setAllLoan]=useState([])

  const fetchallLoan = async () => {
    try {
      const data = await getLoan(UID);
      console.log(data.data.data, "Fetched data");
      setAllLoan(data.data.data);
    } catch (error) {
      console.error("Error fetching allLoan", error);
    }
    setLoading(false);
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setLoanData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  const [dateError, setDateError] = useState("");
  const [dueAmountError, setDueAmountError] = useState("");

  const calculateDues = (amount, startDate, endDate, paymentType) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const monthsDiff =
      (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth()) +
      1; // Total months including start and end

    let duesCount = 0;
    switch (parseInt(paymentType)) {
      case 1: // Monthly
        duesCount = monthsDiff;
        break;
      case 2: // Quarterly
        duesCount = Math.ceil(monthsDiff / 3);
        break;
      case 3: // Half Yearly
        duesCount = Math.ceil(monthsDiff / 6);
        break;
      case 4: // Yearly
        duesCount = Math.ceil(monthsDiff / 12);
        break;
      default:
        duesCount = 0;
    }

    return duesCount;
  };



  const handleChange = (e) => {
    const { name, value } = e.target;

    setLoanData((prev) => {
      const updatedData = { ...prev, [name]: value };

      // Auto-calculate NoofDues if any of the relevant fields change
      if (name === "StartDate" || name === "EndDate" || name === "PaymentType") {
        if (updatedData.StartDate && updatedData.EndDate && updatedData.PaymentType) {
          updatedData.NoofDues = calculateDues(
            updatedData.Amount,
            updatedData.StartDate,
            updatedData.EndDate,
            updatedData.PaymentType
          );

          // If we have DueAmount, also update the Amount field if not manually edited
          if (updatedData.DueAmount && !prev.manualAmountEdit) {
            updatedData.Amount = parseFloat(
              (updatedData.NoofDues * updatedData.DueAmount).toFixed(2) // Added the missing *
            );
          }
        }
      }

      // If NoofDues or DueAmount changes, auto-calculate Amount only if Amount was not manually edited
      if (
        (name === "NoofDues" || name === "DueAmount") &&
        // !prev.manualAmountEdit &&
        updatedData.NoofDues &&
        updatedData.DueAmount
      ) {
        updatedData.Amount = parseFloat(
          (updatedData.NoofDues * updatedData.DueAmount).toFixed(2) // Corrected here as well
        );
      }
      // Track manual edits to the Amount field
      if (name === "Amount") {
        updatedData.manualAmountEdit = true;
      }

      return updatedData;
    });
  };


  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setLoanData((prev) => {
  //     const updatedData = { ...prev, [name]: value };

  //     // Validation: Check if EndDate is lower than StartDate
  //     if (updatedData.StartDate && updatedData.EndDate) {
  //       const startDate = new Date(updatedData.StartDate);
  //       const endDate = new Date(updatedData.EndDate);

  //       if (endDate < startDate) {
  //         setDateError("End Date cannot be earlier than Start Date");
  //       } else {
  //         setDateError(""); // Clear date error if validation passes
  //       }
  //     }

  //     // Validation: Check if Due Amount is greater than Amount
  //     if (
  //       updatedData.DueAmount &&
  //       updatedData.Amount &&
  //       parseFloat(updatedData.DueAmount) > parseFloat(updatedData.Amount)
  //     ) {
  //       setDueAmountError("Due Amount cannot be greater than Amount");
  //     } else {
  //       setDueAmountError(""); // Clear due amount error if validation passes
  //     }

  //     // Auto-calculate NoofDues and DueAmount when Amount, StartDate, EndDate, or PaymentType changes
  //     if (
  //       (name === "Amount" ||
  //         name === "StartDate" ||
  //         name === "EndDate" ||
  //         name === "PaymentType") &&
  //       updatedData.Amount &&
  //       updatedData.StartDate &&
  //       updatedData.EndDate &&
  //       updatedData.PaymentType
  //     ) {
  //       const duesCount = calculateDues(
  //         updatedData.Amount,
  //         updatedData.StartDate,
  //         updatedData.EndDate,
  //         updatedData.PaymentType
  //       );

  //       if (duesCount > 0) {
  //         updatedData.NoofDues = duesCount;
  //         updatedData.DueAmount = parseFloat(
  //           (updatedData.Amount / duesCount).toFixed(2)
  //         ); // Ensure due amount is precise
  //       }
  //     }

  //     // If NoofDues is manually edited, do NOT change DueAmount
  //     if (name === "NoofDues") {
  //       // Do nothing, keep DueAmount as is
  //     }

  //     return updatedData;
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission
    setLoading(true);

    try {
      console.log(LoanData, "Designation");
      const data = {
        ...LoanData,
        UserId: UID,
      };

      const response = await InsertLoan(data);

      // Check if the response is successful (e.g., response status or a success field)
      if (data) {
        toast.success("Loan added successfully!");
        fetchallLoan();
        openaddLoanModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error(
          "The code or Name is already in use. Please use a unique code"
        );
      } else {
        toast.error("Error occurred while adding Category.");
      }
      console.error("Error adding Category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true); // Set loading state to true

    try {
      const data = {
        ...LoanData,
        UserId: UID,
      };
      const response = await InsertLoan(data);
      if (response.data) {
        toast.success("Loan Updated Successfully"); // Show success toast
        fetchallLoan();
        openEditLoanModal();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("Unexpected error"); // Show specific error toast
      } else {
        toast.error("Error occurred while editing Loan"); // General error toast
      }
      console.error("Error editing Loan", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // remove
  const handleDelete = async (LoanId) => {
    const removeData = { Id: LoanId, TableName: "Loan" };
    try {
      const res = await deleteLoan(removeData, UID); // Ensure UID is defined in your scope
      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Loan deleted successfully");
          fetchallLoan();
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Failed to delete the Loan."); // Error toast
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Loan.";
        toast.error("Loan already using cannot delete");
      } else {
        console.error("Error removing Loan:", error);
        toast.error("Error deleting Loan. Please try again.");
      }
    }
  };

  const openModal = (LoanId) => {
    setDeleteLoanId(LoanId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteLoanId(null);
  };

  const confirmDelete = () => {
    if (DeleteLoanId) {
      handleDelete(DeleteLoanId);
    }
    closeModal();
  };

  const clearData = () => {
    setLoanData({
      Id: "",
      Name: "",
      Branch: "",
      Number: "",
      EmployeeId: "",
      DueDate: "",
      Amount: "",
      DueAmount: "",
      PaymentType: "",
      NoofDues: "",
      StartDate: "",
      EndDate: "",
      LoanType: "",
      Year: "",
      month: "",
      UserId: UID,
    });
  };

  const clearDataForEdit = () => {
    setLoanData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Branch: "",
      Number: "",
      EmployeeId: "",
      DueDate: "",
      Amount: "",
      DueAmount: "",
      PaymentType: "",
      NoofDues: "",
      StartDate: "",
      EndDate: "",
      LoanType: "",
      Year: "",
      month: "",
      UserId: UID, // Assuming UID is a variable or state you have defined
    }));
  };

  const [designation, setDesignation] = useState([]);

  const fetchDesignation = async () => {
    try {
      const response = await getDesignation(UID); // Assuming `getDesignation` is an API call function
      setDesignation(response.data.data);
      console.log(response.data.data, "fetched designations");
    } catch (error) {
      console.error("Error fetching designations:", error);
    }
  };

  useEffect(() => {
    fetchDesignation();
  }, []);

  useEffect(() => {
    console.log(Employee, "sdfasdjhfkshdfj");
  }, []);

  const columnsFilter = [
    {
      name: "Sl No",
      cell: (row, index) => {
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "E_Name",
      selector: (row) => row.EmployeeName || "-",
      sortable: true,
    },
    {
      name: "E_Code",
      selector: (row) => row.EmployeeCode || "-",
      sortable: true,
    },
    {
      name: "E_Designation",
      selector: (row) => {
        const desName = designation.find((el) => el.Id === row.DesignationId);
        return desName && desName.Name ? desName.Name : "-";
      },
      sortable: true,
    },


    {
      name: "Profitcenter",
      selector: (row) => row.ProfitcenterName || "-",
      sortable: true,
      width: "150px",

    },
    {
      name: "Department",
      selector: (row) => row.DepartmentName || "-",
      sortable: true,
      width: "250px",
    },
    {
      name: "Loan Type",
      selector: (row) => {
        const loanTypeName = LoanType.find((el) => el.Id === row.LoanType)?.Name;
        return loanTypeName || "-";
      },
      sortable: true,
    },
    // {
    //   name: "Branch",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "-" : row.Branch || "-";
    //   },
    //   sortable: true,
    // },
    {
      name: "Number",
      selector: (row) => row.Number || "-",
      sortable: true,
    },
    {
      name: "SL_Year",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan && loan.Name !== "Society Loan" ? "-" : row.Year || "-";
      },
      sortable: true,
    },
    {
      name: "SL_Month",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan && loan.Name !== "Society Loan" ? "-" : row.month || "-";
      },
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.Amount || "-",
      sortable: true,
    },
    {
      name: "Due Amount",
      selector: (row) => {
        const loan = LoanType.find((el) => el.Id === row.LoanType);
        return loan && loan.Name === "Society Loan" ? "-" : row.DueAmount || 0;
      },
      sortable: true,
    },
    // {
    //   name: "No of Dues",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan" ? "-" : row.NoofDues || 0;
    //   },
    //   sortable: true,
    // },
    // {
    //   name: "Payment Type",
    //   selector: (row) => {
    //     const paymentType = LoanPaymentType.find(
    //       (el) => el.Id === row.PaymentType
    //     );
    //     return paymentType ? paymentType.Name : "-";
    //   },
    //   sortable: true,
    // },
    // {
    //   name: "Due Date",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan"
    //       ? "-"
    //       : row.DueDate
    //       ? new Date(row.DueDate).toLocaleDateString()
    //       : "No date";
    //   },
    //   sortable: true,
    // },
    // {
    //   name: "Start Date",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan"
    //       ? "-"
    //       : row.StartDate
    //       ? new Date(row.StartDate).toLocaleDateString()
    //       : "No date";
    //   },
    //   sortable: true,
    // },
    // {
    //   name: "End Date",
    //   selector: (row) => {
    //     const loan = LoanType.find((el) => el.Id === row.LoanType);
    //     return loan && loan.Name === "Society Loan"
    //       ? "-"
    //       : row.EndDate
    //       ? new Date(row.EndDate).toLocaleDateString()
    //       : "No date";
    //   },
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-center gap-4">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditLoanModal(row)}
            title="Edit Loan"
          >
            <IconEdit className="w-4 h-4" />
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 rounded-md px-3 py-2 flex items-center justify-center"
            onClick={() => openModal(row.Id)}
            title="Delete Loan"
          >
            <IconTrash className="text-white w-4 h-4" />
          </button>
        </div>
      ),
    },
  ];


  const filteredItems = dataFilter?.filter((item) => {
    const lowerCaseFilterText = filterText.toLowerCase().trim();

    // Map related data for the current item
    const employee = Employee.find((el) => el.Id === item.EmployeeId);
    const paymentType = LoanPaymentType.find(
      (el) => el.Id === item.PaymentType
    );
    const loanType = LoanType.find((el) => el.Id === item.LoanType);

    // Extract names from related data
    const employeeName = employee?.Name?.toLowerCase() || "";
    const paymentTypeName = paymentType?.Name?.toLowerCase() || "";
    const loanTypeName = loanType?.Name?.toLowerCase() || "";

    // Check both raw values and mapped names
    return (
      item.Name?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.EmployeeCode?.toString().toLowerCase().includes(lowerCaseFilterText) ||

      item.Branch?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.Number?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.EmployeeId?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.DueDate?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.Amount?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.DueAmount?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.PaymentType?.toString()
        .toLowerCase()
        .includes(lowerCaseFilterText) ||
      item.NoofDues?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.StartDate?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.EndDate?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.LoanType?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      item.Narration?.toString().toLowerCase().includes(lowerCaseFilterText) ||
      // Include mapped names in the filter
      employeeName.includes(lowerCaseFilterText) ||
      paymentTypeName.includes(lowerCaseFilterText) ||
      loanTypeName.includes(lowerCaseFilterText)
    );
  });

  console.log(dataFilter, "jjjjjj");

  const subHeaderComponentMemo = useMemo(() => { }, [
    filterText,
    resetPaginationToggle,
  ]);

  useEffect(() => {
    setLoading(true);
    fetchallLoan();
  }, []);

  useEffect(() => {
    if (allLoan && allLoan.length > 0) {
      const updatedData = allLoan?.map((item, index) => ({
        Id: item.Id || "",
        Slno: index + 1,
        Name: item.Name || "",
        Branch: item.Branch || "",
        Number: item.Number || "",
        EmployeeId: item.EmployeeId || "",
        DueDate: item.DueDate || "",
        Amount: item.Amount || "",
        DueAmount: item.DueAmount || "",
        PaymentType: item.PaymentType || "",
        NoofDues: item.NoofDues || "",
        EmployeeName: item.EmployeeName || "",
        StartDate: item.StartDate || "",
        EndDate: item.EndDate || "",
        LoanType: item.LoanType || "",
        UserId: UID,
        DesignationId: item.DesignationId || "",
        month: item.month || "",
        Year: item.Year || "",
        EmployeeCode: item.EmployeeCode || "",
        ProfitcenterName: item.ProfitcenterName || "",
        DepartmentName: item.DepartmentName || "",



      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([]);
    }
  }, [allLoan, UID]); // Ensure dependencies include allLoan and UID

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults); // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };
  const EmployeeOptions = Employee?.map((employee) => ({
    value: employee.Id,
    label: employee.EmployeeNameWithCode,
  }));

  const defaultValue = LoanData?.EmployeeId
    ? EmployeeOptions?.find((option) => option.value === LoanData?.EmployeeId)
    : null;

  const currentYear = new Date().getFullYear();
  const futureYears = 5;
  const years = [];
  for (let year = currentYear; year <= currentYear + futureYears; year++) {
    years.push(year);
  }


  const [editmode, seteditmode] = useState(true)

  const handleclick = () => {
    seteditmode(false)
  }



  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Loan?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete} // Confirm the deletion
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-8">
        <div className="flex gap-[20px] mb-2 items-center">
          <Breadcrumb title="Loan section" />
          {editmode == true &&
            <Link to="/LoanAmountEdit">
              <button onClick={handleclick} className="btn btn-success">Click here to edit Society Loan for all employees</button>
            </Link>
          }

        </div>

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Emp Name/Dep/LoanType/PaymentType/Loan"
                className="w-[450px] px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button onClick={handleClear} className="btn btn-danger">
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button onClick={openaddLoanModal} className="btn btn-primary">
            Add New
          </button>
        </div>
      </div>

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={allLoan}
          onFilter={handleFilter}
        />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>

      {/* ===============================================Add===================================================== */}

      {addLoanModal && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-[800px] max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-4 bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-lg font-medium px-4 py-4 mb-6 text-center border-b border-border">
                  Add Loan
                  <button
                    onClick={openaddLoanModal}
                    className="absolute top-2 right-4 btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </h5>
                <div className="my-6 px-4 max-h-[700px] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-4">
                    {/* Always Visible Fields */}
                    <div className="col-span-6">
                      <div className="form-group flex flex-col">
                        <label>
                          Employee <span className="text-red-500">*</span>
                        </label>
                        <Select
                          name="EmployeeId"
                          value={defaultValue}
                          onChange={handleSelectChange}
                          required
                          options={EmployeeOptions}
                          isClearable
                          placeholder="Select Employee"
                          className="w-full"
                          classNamePrefix="react-select"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused
                                ? "#2563eb"
                                : "#e5e7eb",
                              boxShadow: state.isFocused
                                ? "0 0 0 1px #2563eb"
                                : "none",
                              "&:hover": { borderColor: "#2563eb" },
                            }),
                            option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isSelected
                                ? "#2563eb"
                                : state.isFocused
                                  ? "#e5e7eb"
                                  : "white",
                              color: state.isSelected ? "white" : "black",
                              "&:hover": { backgroundColor: "#e5e7eb" },
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-span-6">
                      <div className="form-group flex flex-col">
                        <label>
                          Loan Type <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="loanType"
                          name="LoanType"
                          value={LoanData.LoanType}
                          onChange={handleChange}
                          className="border p-2 rounded"
                          required
                        >
                          <option value="" disabled selected>
                            Select Loan Type
                          </option>
                          {LoanType?.map((item) => (
                            <option key={item.Id} value={item.Id}>
                              {item.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Conditional Fields */}
                    {LoanType.find((el) => el.Id === LoanData.LoanType)
                      ?.Name === "Society Loan" ? (
                      <>
                        {/* Name Field */}
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id === LoanData.LoanType
                                )?.Name
                              }{" "}
                              Name
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              id="name"
                              name="Name"
                              placeholder="Name"
                              value={LoanData.Name}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                              onBlur={(e) => {
                                handleChange({
                                  target: {
                                    name: "Name",
                                    value: e.target.value.trim(),
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              id="amount"
                              name="Amount"
                              placeholder="Amount"
                              onWheel={(e) => e.target.blur()}
                              value={LoanData.Amount}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id === LoanData.LoanType
                                )?.month
                              }{" "}
                              Month
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              id="month"
                              name="month"
                              value={LoanData.month}
                              onChange={(e) => handleChange(e)}
                              required
                              className="border p-2 rounded"
                            >
                              <option value="" disabled selected>
                                Select Month
                              </option>
                              {[
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December",
                              ].map((month) => (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id === LoanData.LoanType
                                )?.Year
                              }{" "}
                              Year
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              name="Year"
                              value={LoanData.Year || ""}
                              onChange={(e) =>
                                setLoanData((prev) => ({
                                  ...prev,
                                  Year: e.target.value,
                                }))
                              }
                              required
                              className="border p-2 rounded"
                            >
                              <option value="" disabled>
                                Year
                              </option>
                              {years.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Name <span className="text-red-500">*</span>
                            </label>

                            {LoanType.find((el) => el.Id === LoanData.LoanType)?.Name === "Bank Loan" ? (
                              <select
                                id="name"
                                name="Name"
                                value={LoanData.Name}
                                onChange={handleChange}
                                onBlur={(e) => {
                                  handleChange({
                                    target: {
                                      name: "Name",
                                      value: e.target.value.trim(),
                                    },
                                  });
                                }}
                                required
                                className="border p-2 rounded"
                              >
                                <option value="">-- Select Bank --</option>
                                {BankName.map((el, idx) => (
                                  <option key={idx} value={el.Name}>
                                    {el.Name}
                                  </option>
                                ))}
                              </select>

                            ) : (
                              <input
                                type="text"
                                id="name"
                                name="Name"
                                placeholder="Name"
                                value={LoanData.Name}
                                onChange={handleChange}
                                required
                                onBlur={(e) => {
                                  handleChange({
                                    target: {
                                      name: "Name",
                                      value: e.target.value.trim(),
                                    },
                                  });
                                }}
                                className="border p-2 rounded"
                              />
                            )}
                          </div>

                        </div>
                        {/* All Fields */}
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Branch <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              id="branch"
                              name="Branch"
                              placeholder="Branch"
                              value={LoanData.Branch}
                              onChange={handleChange}
                              required
                              onBlur={(e) => {
                                handleChange({
                                  target: {
                                    name: "Branch",
                                    value: e.target.value.trim(),
                                  },
                                });
                              }}
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id == LoanData.LoanType
                                )?.Name
                              }{" "}
                              Number
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              id="number"
                              name="Number"
                              placeholder="Number"
                              value={LoanData.Number}
                              onChange={handleChange}
                              onWheel={(e) => e.target.blur()}
                              required
                              className="border p-2 rounded"
                              onBlur={(e) => {
                                handleChange({
                                  target: {
                                    name: "Number",
                                    value: e.target.value.trim(),
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Amount
                              {/* <span className="text-red-500">*</span> */}
                            </label>
                            <input
                              type="number"
                              id="amount"
                              name="Amount"
                              placeholder="Amount"
                              onWheel={(e) => e.target.blur()}
                              value={LoanData.Amount}
                              onChange={handleChange}
                              // required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        {/* Start Date, End Date, and Payment Type moved before Due Amount */}
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Start Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              id="startDate"
                              name="StartDate"
                              value={LoanData.StartDate}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              End Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              id="endDate"
                              name="EndDate"
                              value={LoanData.EndDate}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                            {dateError && (
                              <div style={{ color: "red", marginTop: "10px" }}>
                                {dateError}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Payment Type{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              id="paymentType"
                              name="PaymentType"
                              value={LoanData.PaymentType}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            >
                              <option value="" disabled selected>
                                Select Payment Type
                              </option>
                              {LoanPaymentType?.map((item) => (
                                <option key={item.Id} value={item.Id}>
                                  {item.Name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Due Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              id="dueAmount"
                              name="DueAmount"
                              placeholder="Due Amount"
                              onWheel={(e) => e.target.blur()}
                              value={LoanData.DueAmount}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                            {dueAmountError && (
                              <div style={{ color: "red", marginTop: "10px" }}>
                                {dueAmountError}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Number of Dues{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              id="noOfDues"
                              name="NoofDues"
                              onWheel={(e) => e.target.blur()}
                              placeholder="Number of Dues"
                              value={LoanData.NoofDues}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Due Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              id="dueDate"
                              name="DueDate"
                              value={LoanData.DueDate}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="px-4 flex gap-4 justify-end py-4">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openaddLoanModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {EditLoanModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-[800px] max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-4 bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-lg font-medium px-4 py-4 mb-6 text-center border-b border-border">
                  Edit Loan
                  <button
                    onClick={openEditLoanModal}
                    className="absolute top-2 right-4 btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </h5>
                <div className="my-6 px-4 max-h-[700px] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-4">
                    {/* Always Visible Fields */}
                    <div className="col-span-6">
                      <div className="form-group flex flex-col">
                        <label>
                          Employee <span className="text-red-500">*</span>
                        </label>
                        <Select
                          name="EmployeeId"
                          value={defaultValue}
                          required
                          onChange={handleSelectChange}
                          options={EmployeeOptions}
                          isClearable
                          placeholder="Select Employee"
                          className="w-full"
                          classNamePrefix="react-select"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused
                                ? "#2563eb"
                                : "#e5e7eb",
                              boxShadow: state.isFocused
                                ? "0 0 0 1px #2563eb"
                                : "none",
                              "&:hover": { borderColor: "#2563eb" },
                            }),
                            option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isSelected
                                ? "#2563eb"
                                : state.isFocused
                                  ? "#e5e7eb"
                                  : "white",
                              color: state.isSelected ? "white" : "black",
                              "&:hover": { backgroundColor: "#e5e7eb" },
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-span-6">
                      <div className="form-group flex flex-col">
                        <label>
                          Loan Type <span className="text-red-500">*</span>
                        </label>
                        <select
                          id="loanType"
                          name="LoanType"
                          value={LoanData.LoanType}
                          onChange={handleChange}
                          className="border p-2 rounded"
                          required
                        >
                          <option value="" disabled selected>
                            Select Loan Type
                          </option>
                          {LoanType?.map((item) => (
                            <option key={item.Id} value={item.Id}>
                              {item.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Conditional Fields */}
                    {LoanType.find((el) => el.Id === LoanData.LoanType)
                      ?.Name === "Society Loan" ? (
                      <>
                        {/* Name Field */}
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id === LoanData.LoanType
                                )?.Name
                              }{" "}
                              Name
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              id="name"
                              name="Name"
                              placeholder="Name"
                              value={LoanData.Name}
                              onChange={handleChange}
                              required
                              onBlur={(e) => {
                                handleChange({
                                  target: {
                                    name: "Name",
                                    value: e.target.value.trim(),
                                  },
                                });
                              }}
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              id="amount"
                              name="Amount"
                              placeholder="Amount"
                              onWheel={(e) => e.target.blur()}
                              value={LoanData.Amount}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id === LoanData.LoanType
                                )?.month
                              }{" "}
                              Month
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              id="month"
                              name="month"
                              value={LoanData.month}
                              onChange={(e) => handleChange(e)}
                              required
                              className="border p-2 rounded"
                            >
                              <option value="" disabled selected>
                                Select Month
                              </option>
                              {[
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December",
                              ].map((month) => (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id === LoanData.LoanType
                                )?.Year
                              }{" "}
                              Year
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              name="Year"
                              value={LoanData.Year || ""}
                              onChange={(e) =>
                                setLoanData((prev) => ({
                                  ...prev,
                                  Year: e.target.value,
                                }))
                              }
                              required
                              className="border p-2 rounded"
                            >
                              <option value="" disabled selected>
                                Year
                              </option>

                              {years.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Name <span className="text-red-500">*</span>
                            </label>

                            {LoanType.find((el) => el.Id === LoanData.LoanType)?.Name === "Bank Loan" ? (
                              <select
                                id="name"
                                name="Name"
                                value={LoanData.Name}
                                onChange={handleChange}
                                onBlur={(e) => {
                                  handleChange({
                                    target: {
                                      name: "Name",
                                      value: e.target.value.trim(),
                                    },
                                  });
                                }}
                                required
                                className="border p-2 rounded"
                              >
                                <option value="">-- Select Bank --</option>
                                {BankName.map((el, idx) => (
                                  <option key={idx} value={el.Name}>
                                    {el.Name}
                                  </option>
                                ))}
                              </select>

                            ) : (
                              <input
                                type="text"
                                id="name"
                                name="Name"
                                placeholder="Name"
                                value={LoanData.Name}
                                onChange={handleChange}
                                required
                                onBlur={(e) => {
                                  handleChange({
                                    target: {
                                      name: "Name",
                                      value: e.target.value.trim(),
                                    },
                                  });
                                }}
                                className="border p-2 rounded"
                              />
                            )}
                          </div>

                        </div>
                        {/* All Fields */}
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Branch <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              id="branch"
                              name="Branch"
                              placeholder="Branch"
                              value={LoanData.Branch}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                              onBlur={(e) => {
                                handleChange({
                                  target: {
                                    name: "Branch",
                                    value: e.target.value.trim(),
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              {
                                LoanType.find(
                                  (el) => el.Id == LoanData.LoanType
                                )?.Name
                              }{" "}
                              Number
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              id="number"
                              name="Number"
                              placeholder="Number"
                              value={LoanData.Number}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                              onBlur={(e) => {
                                handleChange({
                                  target: {
                                    name: "Number",
                                    value: e.target.value.trim(),
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Amount
                              {/* <span className="text-red-500">*</span> */}
                            </label>
                            <input
                              type="number"
                              id="amount"
                              name="Amount"
                              placeholder="Amount"
                              onWheel={(e) => e.target.blur()}
                              value={LoanData.Amount}
                              onChange={handleChange}
                              // required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        {/* Start Date, End Date, and Payment Type moved before Due Amount */}
                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Start Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              id="startDate"
                              name="StartDate"
                              value={
                                LoanData.StartDate
                                  ? new Date(LoanData.StartDate)
                                    .toISOString()
                                    .split("T")[0]
                                  : ""
                              }
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              End Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              id="endDate"
                              name="EndDate"
                              value={
                                LoanData.EndDate
                                  ? new Date(LoanData.EndDate)
                                    .toISOString()
                                    .split("T")[0]
                                  : ""
                              }
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                            {dateError && (
                              <div style={{ color: "red", marginTop: "10px" }}>
                                {dateError}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Payment Type{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              id="paymentType"
                              name="PaymentType"
                              value={LoanData.PaymentType}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            >
                              <option value="" disabled selected>
                                Select Payment Type
                              </option>
                              {LoanPaymentType?.map((item) => (
                                <option key={item.Id} value={item.Id}>
                                  {item.Name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Due Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              id="dueAmount"
                              name="DueAmount"
                              placeholder="Due Amount"
                              onWheel={(e) => e.target.blur()}
                              value={LoanData.DueAmount}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                            {dueAmountError && (
                              <div style={{ color: "red", marginTop: "10px" }}>
                                {dueAmountError}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Number of Dues{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              id="noOfDues"
                              name="NoofDues"
                              placeholder="Number of Dues"
                              value={LoanData.NoofDues}
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>

                        <div className="col-span-6">
                          <div className="form-group flex flex-col">
                            <label>
                              Due Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              id="dueDate"
                              name="DueDate"
                              value={
                                LoanData.DueDate
                                  ? new Date(LoanData.DueDate)
                                    .toISOString()
                                    .split("T")[0]
                                  : ""
                              }
                              onChange={handleChange}
                              required
                              className="border p-2 rounded"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="px-4 flex gap-4 justify-end py-4">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"></div>
        </>
      )}
    </>
  );
}
